import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import { Crest, SectionTitle } from "./common";

// Golden Boot standings rendered from our own /api/top-scorers data.
export function TopScorers({ limit, showTitle = true }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { client.get("/top-scorers").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows || rows.length === 0) return null;
  const list = limit ? rows.slice(0, limit) : rows;
  return (
    <div data-testid="top-scorers">
      {showTitle && <SectionTitle kicker="Golden Boot · After Matchday 28" testid="top-scorers-title">Top goal scorers</SectionTitle>}
      <div className="overflow-hidden rounded-sm border border-pslborder bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-green text-cream text-[11px] uppercase tracking-wide">
              <th className="py-2.5 px-2 text-center w-8">#</th>
              <th className="py-2.5 px-2 text-left">Player</th>
              <th className="py-2.5 px-2 text-left hidden sm:table-cell">Club</th>
              <th className="py-2.5 px-2 text-center w-16">Goals</th>
            </tr>
          </thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.rank} className="border-t border-pslborder hover:bg-cream transition-colors" data-testid={`scorer-row-${r.rank}`}>
                <td className={`py-2 px-2 text-center font-head font-bold ${r.rank === 1 ? "text-gold" : "text-ink/50"}`}>{r.rank}</td>
                <td className="py-2 px-2">
                  <div className="flex items-center gap-2 min-w-0">
                    <span className="sm:hidden"><Crest slug={r.club_slug} name={r.club} size={20} /></span>
                    <span className="font-semibold text-ink truncate">{r.player}</span>
                  </div>
                </td>
                <td className="py-2 px-2 hidden sm:table-cell">
                  <Link to={`/clubs/${r.club_slug}`} className="flex items-center gap-2 text-ink/70 hover:text-green">
                    <Crest slug={r.club_slug} name={r.club} size={20} />
                    <span className="truncate">{r.club}</span>
                  </Link>
                </td>
                <td className="py-2 px-2 text-center font-head font-black text-green tabular text-base">{r.goals}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
